import { render, staticRenderFns } from "./PriceInfoWithSplitit.vue?vue&type=template&id=78363fe6&scoped=true&"
import script from "./PriceInfoWithSplitit.vue?vue&type=script&lang=js&"
export * from "./PriceInfoWithSplitit.vue?vue&type=script&lang=js&"
import style0 from "./PriceInfoWithSplitit.vue?vue&type=style&index=0&id=78363fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78363fe6",
  null
  
)

export default component.exports